//
//
//
//
//
//
//
//
//
//
//
//
//
import Entries from 'src/components/Entries';
export default {
  props: {
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    canAddTime: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Entries: Entries
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show: function show() {
      this.$refs.dialog.show();
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide: function hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide: function onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },
    onOKClick: function onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok'); // or with payload: this.$emit('ok', { ... })
      // then hiding dialog

      this.hide();
    },
    onCancelClick: function onCancelClick() {
      // we just need to hide dialog
      this.hide();
    }
  }
};